<template>
  <div id="app">
    <div class="logo">
      <h1 id="title">Impressions Photography - Formerly Karen Fleck Photography</h1>
      <h2 id="tagline"><i>Portaits with personality</i></h2>
    </div>
    <NavBar v-if="!mobile"/>
    <MobileNavBar v-if="mobile" />
    <router-view/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import MobileNavBar from '@/components/MobileNavBar'

export default {
  name: 'App',
  components: {
    NavBar,
    MobileNavBar
  },

  data () {
    return {
      mobile: false
    }
  },

  created () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true
    }
  }
}
</script>

<style>
#app {
  font-family: 'Garamond', Georgia, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  max-width: 50em;
  margin: auto auto;
}

body {
  background-image: url('./assets/background.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: fixed;
}

.logo {
  color: #00a7af;
  border-bottom: solid #00a7af;
}

#tagline {
  color: #575f60;
}
</style>



// WEBPACK FOOTER //
// src/App.vue